import { render, staticRenderFns } from "./CloudAccountAssistantShortcut.vue?vue&type=template&id=500d0c3c&scoped=true"
import script from "./CloudAccountAssistantShortcut.vue?vue&type=script&lang=js"
export * from "./CloudAccountAssistantShortcut.vue?vue&type=script&lang=js"
import style0 from "./CloudAccountAssistantShortcut.vue?vue&type=style&index=0&id=500d0c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500d0c3c",
  null
  
)

export default component.exports